import React from "react";

export default function FA5_Genders() {
  return (
    <div className="p-6 max-w-3xl mx-auto">
      <h2 className="text-2xl font-semibold mb-2">FA5_Genders</h2>
      <p>Route: /icons/fa5/genders</p>
    </div>
  );
}
